export default __webpack_public_path__ + "static/media/show.653da2c4.svg";